<script>
import isEmpty from 'lodash/isEmpty';
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
import TrekLoading from '@/components/TrekLoading';
import TrekButton from '@/components/TrekButton';
import CartSummary from '@/components/cart/CartSummary';
import CartProductsContainer from '@/components/cart/CartProductsContainer';
import CartProductsList from '@/components/cart/CartProductsList';
import Tabs from '@/components/tabs/Tabs';
import TabPane from '@/components/tabs/TabPane';

export default {
  components: {
    TrekLoading,
    TrekButton,
    CartSummary,
    CartProductsContainer,
    CartProductsList,
    Tabs,
    TabPane,
  },

  data() {
    return {
      loading: true,
      selectedTabName: '',
    };
  },

  computed: {
    cartIsEmpty() {
      return (
        (isEmpty(this.cartSummary) && isEmpty(this.parts) && isEmpty(this.bikes)) ||
        ((!this.parts || !this.parts.length) && (!this.bikes || !this.bikes.length))
      );
    },

    tabSelected: {
      get() {
        return this.selectedTabName || (!this.cartEmpty && isEmpty(this.bikes) ? 'parts' : 'bikes');
      },
      set(name) {
        this.selectedTabName = name;
      },
    },

    ...mapState('cart', ['bikes', 'parts', 'cartSummary', 'cartId', 'containers']),

    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  created() {
    this.setUseToastInterceptor(false);
    this.setFetchCallback(this.onCartFetchResponse);
    this.fetchCart();
  },

  methods: {
    navigateTo(url) {
      window.location.href = url;
    },

    changeGridTab(tab) {
      this.tabSelected = tab;
      $('html, body').animate(
        {
          scrollTop: $(this.$refs.checkoutGrids.$el).offset().top - 100,
        },
        500
      );
    },

    onCartFetchResponse() {
      if (this.cartId && this.cartId.length) {
        if (this.selectedTabName === 'parts' && isEmpty(this.parts) && !isEmpty(this.bikes)) {
          this.selectedTabName = 'bikes';
        } else if (this.selectedTabName === 'bikes' && isEmpty(this.bikes) && !isEmpty(this.parts)) {
          this.selectedTabName = 'parts';
        }
      } else {
        this.selectedTabName = 'bikes';
      }

      this.fetchMiniCart();
      this.loading = false;
    },

    ...mapActions('cart', ['fetchCart']),

    ...mapActions('miniCart', ['fetchMiniCart']),

    ...mapMutations('cart', ['setFetchCallback']),

    ...mapMutations('global', ['setUseToastInterceptor']),
  },
};
</script>
